const PROPERTY_TYPES = [
    { value: "apartment", label: "Căn hộ" },
    { value: "villa", label: "Biệt thự" },
    { value: "shophouse", label: "Shophouse" },
    { value: "condotel", label: "Condotel" },
    { value: "penthouse", label: "Penthouse" },
    { value: "duplex", label: "Duplex" },
  ];
  
  const SOLD_STATUS_OPTIONS = [
    { value: "all", label: "Tất cả" },
    { value: "true", label: "Đã bán" },
    { value: "false", label: "Chưa bán" },
  ];
  
  export function PropertyFilters({ filters, onChange }) {
    return (
      <div className="flex gap-4 mb-4 flex-wrap">
        <input
          type="text"
          name="title"
          value={filters.title}
          onChange={onChange}
          placeholder="Tên bất động sản"
          className="border px-3 py-1 rounded"
        />
  
        <select
          name="propertyType"
          value={filters.propertyType}
          onChange={onChange}
          className="border px-3 py-1 rounded"
        >
          <option value="">Tất cả loại</option>
          {PROPERTY_TYPES.map(({ value, label }) => (
            <option key={value} value={value}>{label}</option>
          ))}
        </select>
  
        <select
          name="isSold"
          value={filters.isSold}
          onChange={onChange}
          className="border px-3 py-1 rounded"
        >
          {SOLD_STATUS_OPTIONS.map(({ value, label }) => (
            <option key={value} value={value}>{label}</option>
          ))}
        </select>
      </div>
    );
  }